import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Point from '../../Utility/Point';
import Text from '../Text';
import AnimationComponent from '../../Component/Animation';
import { TextStyleOptions } from 'pixi.js';

export default class SpeechBubble extends GameObject {
    public onCreate(params: {
        x: number;
        y: number;
        text: string;
        textStyle: TextStyleOptions;
        visible?: boolean;
        name?: string;
    }): void {
        if (params.name) {
            this.name = params.name;
        }

        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, params);

        // Add the base sprite.
        const baseSprite: Sprite = GameObject.Instantiate(Sprite, {
            texture: 'speech_bubble',
            anchor: new Point(0.5, 1),
        });

        this.addChild(baseSprite);

        // Add the message.
        const message: Text = GameObject.Instantiate(Text, {
            position: new Point(0, -70),
            anchor: new Point(0.5, 0.5),
            bounds: new Point(170, 70),
            text: params.text,
            style: params.textStyle,
        });

        this.addChild(message);

        // Animate.
        this.addComponent(AnimationComponent);
        /*
        this.addComponent(AnimationComponent, {
            playOnStart: false,
            clipName: 'SpeechBubblePopUp',
        });
        */
    }
}
